import { all, takeLatest, put, call, fork } from "redux-saga/effects";
import { actions, constants } from "./actions";
import { apiV2 } from "../../services/api";
import { formUtils } from "./utils";


const { checkFields, formatPayload } = formUtils();
const { providers: providersApi } = apiV2;
const { SUBMIT_PROVIDER_FORM, FETCH_PROVIDER_LIST, DELETE_PROVIDER } =
  constants;
const {
  submitProviderForm,
  fetchProviderList,
  deleteProvider,
  updateProvider,
  fetchProvider,
} = actions;

// Action sagas - async
function* submitProviderFormRequest() {
  yield takeLatest("SUBMIT_PROVIDER_FORM/REQUEST", function* ({ payload }) {
    const validationErrors = checkFields(payload);
    if (validationErrors.length > 0) {
      yield put(
        submitProviderForm.failure({
          source: SUBMIT_PROVIDER_FORM,
          message: validationErrors,
        })
      );
      return;
    }
    try {
      const createProviderOptions = formatPayload(payload);
      yield call(providersApi.create, createProviderOptions);
      yield put(
        submitProviderForm.success({
          source: SUBMIT_PROVIDER_FORM,
          message: "Provider successfully created.",
        })
      );
    } catch (err) {
      yield put(
        submitProviderForm.failure({
          source: SUBMIT_PROVIDER_FORM,
          message: "Unable to create provider, please try again.",
        })
      );
    }
  });
}

function* deleteProviderRequest() {
  yield takeLatest("DELETE_PROVIDER/REQUEST", function* ({ payload }) {
    try {
      yield call(providersApi.delete, payload.id);
      yield put(
        deleteProvider.success({
          source: DELETE_PROVIDER,
          message: "Provider successfully deleted.",
          deletedProviderId: payload.id,
        })
      );
    } catch (err) {
      yield put(
        deleteProvider.failure({
          source: DELETE_PROVIDER,
          message: "Unable to delete provider, please try again.",
        })
      );
    }
  });
}

function* updateProviderRequest() {
  yield takeLatest("UPDATE_PROVIDER/REQUEST", function* ({ payload }) {
    try {
      const validationErrors = checkFields(payload);
      if (validationErrors.length > 0) {
        yield put(
          updateProvider.failure({
            message: validationErrors,
          })
        );
        return;
      }
      const updateProviderOptions = formatPayload(payload, true);
      delete updateProviderOptions.id;
      yield call(providersApi.update, payload.id, updateProviderOptions);
      yield put(
        updateProvider.success({ message: "Provider successfully updated." })
      );
    } catch (err) {
      yield put(
        updateProvider.failure({
          message: ["Unable to update provider, please try again."],
        })
      );
    }
  });
}

function* fetchProviderRequest() {
  yield takeLatest("FETCH_PROVIDER/REQUEST", function* ({ payload }) {
    try {
      const provider = yield call(providersApi.getById, payload.id);
      yield put(
        fetchProvider.success({
          provider: provider,
        })
      );
    } catch (err) {
      yield put(
        fetchProvider.failure({
          message: ["Unable to fetch provider, please try again."],
        })
      );
    }
  });
}

function* fetchProviderListRequest() {
  yield takeLatest("FETCH_PROVIDER_LIST/REQUEST", function* ({ payload }) {
    try {
      const providers = yield call(providersApi.getAll);
      yield put(
        fetchProviderList.success({
          source: FETCH_PROVIDER_LIST,
          list: providers,
        })
      );
    } catch (err) {
      yield put(
        fetchProviderList.failure({
          source: FETCH_PROVIDER_LIST,
          message: "Unable to load providers, please try again.",
          statusCode: err.statusCode,
        })
      );
    }
  });
}

// Watcher sagas
export default function* rootSaga() {
  yield all([
    fork(submitProviderFormRequest),
    fork(fetchProviderListRequest),
    fork(deleteProviderRequest),
    fork(updateProviderRequest),
    fork(fetchProviderRequest),
  ]);
}
